import { render } from "./DashboardSearch.vue?vue&type=template&id=28ba0bc4&scoped=true"
import script from "./DashboardSearch.vue?vue&type=script&lang=ts"
export * from "./DashboardSearch.vue?vue&type=script&lang=ts"

import "./DashboardSearch.vue?vue&type=style&index=0&id=28ba0bc4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28ba0bc4"

export default script